import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { CoreLink, Paragraph } from '@uncinc/react-drupal-core';
import { List } from 'immutable';
import { useAspectRatio } from '../../../../helpers/useAspectRatio';

import {
  Container,
  ParallaxIllustrations,
  DynamicMediaItem,
} from '../../../../components';

import './style.scss';

const NodeHomePage = ({ entity, className }) => {
  const classes = classNames(className, 'HomePage');

  const { t } = useTranslation();
  const backgroundImage = entity.getIn(['field_image', 0], null);
  const body = entity.getIn(['body', 0, 'value'], '');
  const links = entity.getIn(['field_menu'], '');

  const aspectRatio = useAspectRatio({
    small: '3_2',
    medium: '2_1',
    large: '7_3',
    xlarge: '8_3',
  });

  return (
    // eslint-disable-next-line react/no-unknown-property
    <article typeof="schema:WebPage" className={classes}>

      {backgroundImage && (
        <div className="HomePage__hero">
          <DynamicMediaItem
            className="HomePage__hero__background"
            media={backgroundImage.toJS()}
            imageAspectRatio={aspectRatio}
            alt={backgroundImage.toJS().alt}
          />
        </div>
      )}

      <ParallaxIllustrations
        className="container HomePage__parallax"
        elementClassName="HomePage__parallax__element"
      />

      <div className="HomePage__intro">
        <Container className="HomePage__intro__container">
          <div className="row">
            <div className="col-12 col-md-7 col-xl-8">
              <h1>{body}</h1>
            </div>
            {links && (
              <div className="col-12 col-md-5 col-xl-4">
                <div className="QuickLinks">
                  <p className="QuickLinks__title">{t('go_directly_to')}</p>
                  {links.map((link, index) => {
                    return (
                      <div key={link.getIn(['uuid'], index)} className="QuickLinks__link">
                        <CoreLink href={link.getIn(['alias'], link.getIn(['uri']))}>
                          <i className="icon-after icon-before icon-arrow-right icon-variant-4 moving-arrow" />
                          {link.getIn(['title'])}
                        </CoreLink>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

        </Container>
      </div>

      <div className="Paragraphs">
        {
          entity.getIn(['field_paragraphs'], List()).map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
    </article>
  );
};

export default NodeHomePage;
